import React from 'react';
import {Loader, Dimmer} from 'semantic-ui-react';

const Spinner = () => (
    <Dimmer active>
        <Loader size="huge" content={"对话框生成中..."} />
    </Dimmer>
    
)

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.js